import { lazy } from 'react';

import { SuspenseWrapper } from 'components/suspense-wrappper';

export const Element = lazy(() => import('./platform-page'));

export const PlatformPageLazy = () => (
  <SuspenseWrapper>
    <Element />
  </SuspenseWrapper>
);
